import { omit } from 'lodash-es';
import mergeRefs from 'merge-refs';
import { ComponentPropsWithRef } from 'react';

import { useRellax, UseRellaxOptions } from '@/hooks/useRellax';

type RellaxProps = ComponentPropsWithRef<'div'> &
    UseRellaxOptions<HTMLDivElement>;

export function Rellax({
    ref: refProp,
    center,
    horizontal,
    round,
    speed,
    vertical,
    wrapper,
    ...props
}: RellaxProps) {
    const { className, ...otherProps } = props;

    const rellaxRef = useRellax<HTMLDivElement>({
        center,
        horizontal,
        round,
        speed,
        vertical,
        wrapper,
    });

    const ref = mergeRefs<HTMLDivElement>(rellaxRef, refProp);

    return (
        <div
            {...omit(otherProps, [
                'center',
                'horizontal',
                'round',
                'speed',
                'vertical',
                'wrapper',
            ])}
            ref={ref}
            className={className}
        />
    );
}
